const TRUE_VALUES = new Set(["1", "true", "yes", "on"]);

export const isFreeBetaModeEnabled = () =>
  TRUE_VALUES.has((process.env.REACT_APP_FREE_BETA_MODE || "").trim().toLowerCase());
